import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const EditableTitleStyled = styled.div<{ isEditing?: boolean }>`
  overflow-x: hidden;
  width: ${(props) => (props.isEditing ? '100%' : 'auto')};
`;

export const EditableTitleInput = styled.input<{
  isEditing?: boolean;
}>`
  padding: 7px 16px;
  ${(props) => textStyleCss(props.theme.atlas.typography.semantic.headingH3)};
  border: ${(props) =>
    props.isEditing
      ? `solid 1px ${props.theme.atlas.semantic.color.outline.default}`
      : 'none'};
  &::placeholder {
    color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  }
  &:focus-visible {
    outline: none;
  }
  border-radius: 3px;
  width: 100%;
`;

export const EditableTitleValue = styled.h2<{
  fixedHeight?: boolean;
}>`
  ${(props) => textStyleCss(props.theme.atlas.typography.semantic.headingH3)}
  margin: ${(props) => (props.fixedHeight ? '8px 0' : '0')};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
